import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { api } from "../../lib/api";

export const NoticesBar = ({ refreshKey }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/me/test-notices").then((r) => setD(r.data)).catch(() => setD(null)); }, [refreshKey]);
  if (!d) return null;
  const act = d.items.filter((n) => n.active);
  if (!act.length) return null;
  const toggle = () => {
    setOpen(!open);
    if (!open && d.unread) api.post("/me/test-notices/read").then(() => setD({ ...d, unread: 0 })).catch(() => {});
  };
  return (
    <div className="qv-card-app" style={{ padding: 12, marginBottom: 12, borderLeft: d.unread ? "3px solid #E11D2E" : undefined }} data-testid="notices-bar">
      <button onClick={toggle} style={{ background: "none", border: "none", color: "#fff", display: "flex", gap: 8, alignItems: "center", cursor: "pointer", width: "100%", padding: 0, fontSize: 13 }} data-testid="notices-toggle">
        <Bell size={15} />
        <span style={{ flex: 1, textAlign: "left" }}>{d.unread ? `${d.unread} aviso${d.unread > 1 ? "s" : ""} nuevo${d.unread > 1 ? "s" : ""} sobre tus evaluaciones` : "Avisos de tus evaluaciones"}</span>
        <span style={{ fontSize: 11, color: "#a3a3a3" }}>{open ? "Ocultar" : "Ver"}</span>
      </button>
      {open && act.slice(0, 10).map((n) => (
        <div key={n.id} style={{ fontSize: 12, padding: "6px 0", borderTop: "1px solid rgba(255,255,255,0.06)", marginTop: 6 }} data-testid={`notice-${n.id}`}>
          <b>{n.title}</b> · <span style={{ color: "#a3a3a3" }}>{n.message}</span>
        </div>
      ))}
    </div>
  );
};
